import { createContext, useState } from "react";

export const ReligionContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [religions, setReligions] = useState([]);

    // Make the context object:
    const religionContext = {
        religions,
        setReligions,
    };

    // pass the value in provider and return
    return <ReligionContext.Provider value={religionContext}>{children}</ReligionContext.Provider>;
};

export const { Consumer } = ReligionContext;
